import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../locales/LanguageContext';

const WHATSAPP_NUMBER = '18096977660';

export const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);
  const location = useLocation();
  const { t } = useLanguage();

  // Only show on public pages
  if (location.pathname.startsWith('/admin')) return null;

  return (
    <div className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 flex items-center gap-3">
      {/* Tooltip */}
      <span
        className={`bg-white text-slate-700 text-sm font-medium px-3 py-2 rounded-lg shadow-lg
          transition-all duration-300 whitespace-nowrap pointer-events-none
          ${hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2'}`}
      >
        {t('whatsapp.tooltip')}
      </span>

      {/* Button */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}`}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#20bd5a]
          flex items-center justify-center shadow-lg shadow-black/20
          transition-transform duration-200 hover:scale-110"
        aria-label="WhatsApp"
      >
        <svg viewBox="0 0 32 32" className="w-7 h-7 sm:w-8 sm:h-8 fill-white">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.914 15.914 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.32 22.606c-.39 1.1-1.932 2.012-3.182 2.278-.856.18-1.974.324-5.738-1.234-4.818-1.994-7.916-6.878-8.158-7.196-.232-.318-1.952-2.6-1.952-4.958s1.234-3.518 1.672-3.998c.39-.428 1.03-.624 1.642-.624.198 0 .376.01.536.018.438.02.658.046.946.73.362.856 1.242 3.036 1.35 3.256.11.22.222.518.072.818-.14.308-.264.446-.484.698-.22.252-.43.446-.65.718-.2.238-.426.492-.182.93.244.436 1.084 1.788 2.328 2.896 1.6 1.424 2.946 1.864 3.364 2.072.318.158.698.128.952-.148.322-.352.72-.936 1.124-1.512.288-.41.65-.462.998-.318.354.138 2.24 1.056 2.624 1.248.384.194.642.288.736.45.092.16.092.93-.298 2.03z" />
        </svg>
      </a>
    </div>
  );
};
